import React, { useMemo } from 'react';
import { vendorAccountType } from '@Reducers/AdminShipment/Type';
import { Grid, Paper, Typography } from '@mui/material';
import SBDropdown from '@Components/Dropdown';
import { useFormik } from 'formik';
import { AppDispatch, RootStateType } from '@Store';
import { useDispatch, useSelector } from 'react-redux';
import { addCarrierSettings, updateCarrierSettings } from '@Reducers/User/actions';
import SbButton from '@Components/Button';
import Divider from '@Components/Divider';
import * as Yup from 'yup';
import { linexCarrier } from './Type';
import { setCarrierSettings } from '@Reducers/User';
import {
  DutyTypeOptions,
  PaymentTypeOptions,
  DeclareCurrencyTypeOptions,
} from '../../ViewSingleShipmentAdmin/components/ShipmentProcessingV2/components/Linex/constants';

interface propsTypes {
  onClose: () => void;
  isEditable: boolean;
}

// ... validation schema from above ...
const linexValidationSchema = Yup.object().shape({
  accountNo: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Account value is required'),
        display: Yup.string().required('Account display is required'),
      }),
    )
    .min(1, 'At least one account number is required')
    .required('Account number is required')
    .default([]),

  PaymentType: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Payment Type value is required'),
        display: Yup.string(),
      }),
    )
    .min(1, 'At least one Payment Type is required')
    .required('Payment Type is required')
    .default([]),

  dutyType: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Duty Type value is required'),
        display: Yup.string(),
      }),
    )
    .min(1, 'At least one Duty Type is required')
    .required('Duty Type is required')
    .default([]),
  // serviceCode: Yup.array()
  //   .of(
  //     Yup.object().shape({
  //       value: Yup.string().required('Service Code value is required'),
  //       display: Yup.string(),
  //     }),
  //   )
  //   .min(1, 'At least one Service Code is required')
  //   .required('Service Code is required')
  //   .default([]),
  declareCurrency: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Declare Currency value is required'),
        display: Yup.string(),
      }),
    )
    .min(1, 'At least one Declare Currency is required')
    .required('Declare Currency is required')
    .default([]),
});

const Linex = (props: propsTypes) => {
  const { onClose, isEditable } = props;
  const dispatch = useDispatch<AppDispatch>();
  const { vendersAccount } = useSelector((state: RootStateType) => state.adminShipment);
  const { userDataById, carrierSetting } = useSelector((state: RootStateType) => state.user);

  const accountOptions = useMemo(
    () =>
      vendersAccount?.map((item: vendorAccountType) => ({
        value: `${item.accountNo}-${item._id}`,
        display: item.name,
      })),
    [vendersAccount],
  );

  const { values, setFieldValue, errors, handleSubmit } = useFormik<linexCarrier>({
    enableReinitialize: true,
    validateOnChange: false,
    validationSchema: linexValidationSchema,
    initialValues: {
      ...carrierSetting.linex,
      // type: 'D-D',
    },
    onSubmit(values) {
      if (userDataById?._id) {
        if (carrierSetting.linex._id) {
          dispatch(updateCarrierSettings({ ...carrierSetting.linex, ...values }));
        } else {
          dispatch(addCarrierSettings({ ...carrierSetting.linex, ...values }));
        }
      } else {
        dispatch(setCarrierSettings({ values, carrierType: 'linex' }));
      }
      onClose();
    },
  });

  return (
    <div>
      <>
        <Paper
          variant="outlined"
          sx={{
            my: '2rem',
            p: '2rem',
          }}
        >
          <Grid container item xs={12}>
            <Grid container item mb={3}>
              <Grid item xs={12} md={6}>
                <Typography className="font-medium l-text pb-3">Linex Information</Typography>{' '}
              </Grid>
            </Grid>
            <Grid container item xs={12} md={12} lg={12} columnSpacing={4} rowSpacing={4}>
              <Grid container item columnSpacing={10} rowSpacing={2}>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="accountNo"
                    label={`Linex Account`}
                    required
                    multiple={true}
                    placeholder="Select"
                    name="accountNo"
                    value={values?.accountNo?.map(item => item.value)}
                    options={accountOptions}
                    onChange={(_, selectedObj) => {
                      setFieldValue('accountNo', selectedObj);
                    }}
                    error={Array.isArray(errors.accountNo) ? errors.accountNo.join(', ') : errors.accountNo}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="PaymentType"
                    label={`Payment Type`}
                    required
                    multiple={true}
                    placeholder="Select "
                    name="PaymentType"
                    value={values?.PaymentType?.map(item => item.value)}
                    options={PaymentTypeOptions}
                    onChange={(_, selectedObj) => {
                      setFieldValue('PaymentType', selectedObj);
                    }}
                    error={errors.PaymentType as string}
                  />
                </Grid>
              </Grid>

              <Grid container item columnSpacing={10} rowSpacing={2}>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="dutyType"
                    label={`Duty Type`}
                    required
                    multiple={true}
                    placeholder="Select "
                    name="dutyType"
                    value={values?.dutyType?.map(item => item.value)}
                    options={DutyTypeOptions}
                    onChange={(_, selectedObj) => {
                      setFieldValue('dutyType', selectedObj);
                    }}
                    error={errors.dutyType as string}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="declareCurrency"
                    label={`Declare Currency`}
                    required
                    multiple={true}
                    placeholder="Select "
                    name="declareCurrency"
                    value={values?.declareCurrency?.map(item => item.value)}
                    options={DeclareCurrencyTypeOptions}
                    onChange={(_, selectedObj) => {
                      setFieldValue('declareCurrency', selectedObj);
                    }}
                    error={errors.declareCurrency as string}
                  />
                </Grid>
              </Grid>

              <Divider className="mt-3 mb-3" />
              <Grid container item xs={12} md={12} lg={12} columnSpacing={4} rowSpacing={4}>
                <Grid container item sx={{ gap: '1rem' }}>
                  <Grid item xs={12} sm={5} md={2.6} lg={2.7}>
                    <SbButton
                      type="submit"
                      disabled={!isEditable}
                      variant="contained"
                      sx={{ borderRadius: `4px !important` }}
                      className="w-full"
                      onClick={() => {
                        handleSubmit();
                      }}
                    >
                      Save
                    </SbButton>
                  </Grid>
                  {onClose && (
                    <Grid item xs={12} sm={5} md={2.6} lg={2.7}>
                      <SbButton
                        type="button"
                        sx={{ borderRadius: `4px !important` }}
                        className="w-full"
                        variant="outlined"
                        onClick={onClose}
                      >
                        Cancel
                      </SbButton>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </>
    </div>
  );
};

export default Linex;
